import { useEffect, useRef } from 'react';
import { useStickToBottomContext } from 'use-stick-to-bottom';

import { useAudioPlayerStore } from '@/music/hooks/use-audio-player-store';

// 플레이어 바가 나타나거나 사라지면 스크롤 컨테이너 높이만 줄거나 늘어나는데
// use-stick-to-bottom은 콘텐츠 리사이즈만 관측하므로 하단 고정 상태에 한해 직접 보정
export const PlayerBarScrollSync = () => {
  const hasTrack = useAudioPlayerStore((state) => state.activeTrack !== null);
  const { isAtBottom, scrollToBottom } = useStickToBottomContext();
  const prevHasTrackRef = useRef(hasTrack);

  useEffect(() => {
    if (prevHasTrackRef.current === hasTrack) return;
    prevHasTrackRef.current = hasTrack;
    if (isAtBottom) void scrollToBottom();
  }, [hasTrack, isAtBottom, scrollToBottom]);

  return null;
};
